import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";
import { TextField } from "@pages/AdminDashboard/ui/TextField";
import { ShipAddressFields } from "@types-runway/admin";

const [, , spaceMd] = adminTokens.spacing;

const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceMd}px;
`;

interface AddressFieldsProps {
  fields: ShipAddressFields;
  onChange: (fields: ShipAddressFields) => void;
}

// The fields of the address form on the Ship screen and in the User Search (SHIPUI-R30, USER-R24).
export const AddressFields = ({ fields, onChange }: AddressFieldsProps) => {
  const setField = (name: keyof ShipAddressFields, value: string) =>
    onChange({ ...fields, [name]: value });

  return (
    <Fields>
      <TextField
        label="Street"
        value={fields.street}
        onChange={(event) => setField("street", event.target.value)}
      />
      <TextField
        label="Apartment or suite"
        value={fields.secondary}
        onChange={(event) => setField("secondary", event.target.value)}
      />
      <TextField
        label="City"
        value={fields.city}
        onChange={(event) => setField("city", event.target.value)}
      />
      <TextField
        label="State"
        value={fields.state}
        onChange={(event) => setField("state", event.target.value)}
      />
      <TextField
        label="ZIP code"
        value={fields.postalCode}
        onChange={(event) => setField("postalCode", event.target.value)}
      />
    </Fields>
  );
};
